import {
  CustomTaskOrder,
  CustomTaskOrderSlot,
  GroupByMode,
  ID,
} from '@griply/types';

const isPlainRecord = (value: unknown): value is Record<string, unknown> => {
  if (value === null || value === undefined) {
    return false;
  }
  if (typeof value !== 'object') {
    return false;
  }
  if (Array.isArray(value)) {
    return false;
  }
  return true;
};

const coerceIdArray = (value: unknown): ID[] | undefined => {
  if (!Array.isArray(value)) {
    return undefined;
  }
  return value.filter((entry): entry is ID => typeof entry === 'string');
};

const coerceIdArrayMap = (value: unknown): Record<ID, ID[]> | undefined => {
  if (!isPlainRecord(value)) {
    return undefined;
  }
  const result: Record<ID, ID[]> = {};
  for (const [sectionId, rawArray] of Object.entries(value)) {
    const ids = coerceIdArray(rawArray);
    if (ids === undefined) {
      continue;
    }
    result[sectionId] = ids;
  }
  return result;
};

const coerceSlot = (raw: unknown): CustomTaskOrderSlot | undefined => {
  if (!isPlainRecord(raw)) {
    return undefined;
  }

  const result: CustomTaskOrderSlot = {};

  if (GroupByMode.None in raw) {
    const ids = coerceIdArray(raw[GroupByMode.None]);
    if (ids !== undefined) {
      result[GroupByMode.None] = ids;
    }
  }

  for (const mode of Object.values(GroupByMode)) {
    if (mode === GroupByMode.None) {
      continue;
    }
    if (!(mode in raw)) {
      continue;
    }
    const map = coerceIdArrayMap(raw[mode]);
    if (map === undefined) {
      continue;
    }
    result[mode as Exclude<GroupByMode, GroupByMode.None>] = map;
  }

  return result;
};

export const coerceCustomTaskOrder = (
  raw: unknown,
): CustomTaskOrder | null | undefined => {
  if (raw === undefined) {
    return undefined;
  }
  if (raw === null) {
    return null;
  }
  if (!isPlainRecord(raw)) {
    return undefined;
  }

  const result: CustomTaskOrder = {};

  if ('today' in raw) {
    const today = coerceSlot(raw.today);
    if (today !== undefined) {
      result.today = today;
    }
  }

  if ('allTasks' in raw) {
    const allTasks = coerceSlot(raw.allTasks);
    if (allTasks !== undefined) {
      result.allTasks = allTasks;
    }
  }

  if ('inbox' in raw) {
    const inbox = coerceSlot(raw.inbox);
    if (inbox !== undefined) {
      result.inbox = inbox;
    }
  }

  return result;
};
